import React, { ReactElement } from 'react';
import CardLayout from '../../components/CardLayout';
import EmptyState from '../../components/EmptyState';
import { Pagination } from '../../components/Pagination';
import { Spinner } from 'react-bootstrap';
import EmptyStateSelfSevice from '../../components/EmptyStateSelfSevice';
import TableSkeleton, { ITableColumn } from '../../components/TableSkeleton';

interface ITableLayout {
    children: ReactElement;
    pagination: {
        page: number;
        totalPages: number;
    };
    handlePages: (page: number) => void;
    listLength: number;
    isLoading?: boolean;
    dataName?: string;
    year?: number;
    skeletonColumns?: ITableColumn[];
    skeletonRows?: number;
}

export default function TableLayout({
    children,
    pagination,
    handlePages,
    listLength,
    isLoading = false,
    dataName,
    year,
    skeletonColumns,
    skeletonRows,
}: ITableLayout) {
    const showPagination = pagination.totalPages > 1;
    const hasData = listLength > 0;
    const showSkeleton = isLoading && !!skeletonColumns?.length;

    return (
        <CardLayout classCard="mb-5 mt-5">
            {hasData && !showSkeleton && children}

            {!isLoading &&
                !hasData &&
                (dataName === 'Self service company' ? (
                    <EmptyStateSelfSevice year={year} classHolder="shadow-none" />
                ) : (
                    <EmptyState classHolder="shadow-none" />
                ))}

            {showSkeleton && <TableSkeleton columns={skeletonColumns!} rows={skeletonRows} />}

            {isLoading && !showSkeleton && (
                <div className="text-muted mb-3">
                    <Spinner className="mr-2" animation="border" size="sm" />
                    Loading {dataName ? dataName : 'data'}...
                </div>
            )}

            {hasData && showPagination && (
                <Pagination
                    page={pagination.page}
                    totalPages={pagination.totalPages}
                    handlePagination={handlePages}
                    disabled={isLoading}
                />
            )}
        </CardLayout>
    );
}
